var _rect, _path, _path2, _path3, _path4, _rect2, _rect3, _path5, _circle, _circle2, _circle3, _circle4, _circle5, _circle6;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSportsThumbnail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "thumbnail-background",
    x: 0.5,
    y: 0.5,
    width: 101,
    height: 101,
    rx: 10.5,
    fill: "#408C86",
    stroke: "#1E1E1E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-podium",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41 62C38.2386 62 36 64.2386 36 67V78H17C14.2386 78 12 80.2386 12 83V101H52H92V83C92 80.2386 89.7614 78 87 78H68V67C68 64.2386 65.7614 62 63 62H41Z",
    fill: "#245661"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.6091 11.6842C35.91 11.6842 35.3433 12.251 35.3433 12.9501C35.3433 13.6492 35.91 14.2159 36.6091 14.2159H38.8883V16.4443H32.8101C32.5916 16.4443 32.3823 16.5326 32.2298 16.6892C32.0773 16.8457 31.9945 17.0572 32.0003 17.2757C32.0445 18.957 32.4253 21.5059 33.4485 23.7142C34.4481 25.8717 36.1492 27.8678 38.8883 28.1708V30.9251C38.8883 30.9251 41.0534 37.6173 48.5076 39.2001V48.6047L41.1478 51.6713C40.3931 51.9857 39.9015 52.7232 39.9015 53.5408V59.7856C39.9015 60.9042 40.8082 61.8109 41.9268 61.8109H62.1802C63.2988 61.8109 64.2055 60.9042 64.2055 59.7856V53.5408C64.2055 52.7232 63.7139 51.9857 62.9592 51.6713L55.0899 48.3924V39.2006C62.5458 37.6186 64.7114 30.9251 64.7114 30.9251V28.1704C67.4572 27.858 69.1545 25.8089 70.1495 23.6077C71.1704 21.3492 71.5505 18.7419 71.5945 17.0226C71.6001 16.8042 71.5173 16.5928 71.3648 16.4364C71.2123 16.2799 71.0031 16.1917 70.7847 16.1917H64.7114V14.2159H67.4956C68.1947 14.2159 68.7614 13.6492 68.7614 12.9501C68.7614 12.251 68.1947 11.6842 67.4956 11.6842L36.6091 11.6842ZM38.8883 26.5368V18.0646H33.6678C33.7943 19.5304 34.1655 21.4076 34.9186 23.0331C35.7766 24.8848 37.0476 26.2569 38.8883 26.5368ZM68.673 22.9403C67.8121 24.8449 66.5406 26.2468 64.7114 26.5355V17.8119H69.9288C69.8039 19.3214 69.432 21.2613 68.673 22.9403Z",
    fill: "#FFC86F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-trophy",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.6091 11.6842C35.91 11.6842 35.3433 12.251 35.3433 12.9501C35.3433 13.6492 35.91 14.2159 36.6091 14.2159H38.8883V16.4443H32.8101C32.5916 16.4443 32.3823 16.5326 32.2298 16.6892C32.0773 16.8457 31.9945 17.0572 32.0003 17.2757C32.0445 18.957 32.4253 21.5059 33.4485 23.7142C34.4481 25.8717 36.1492 27.8678 38.8883 28.1708V30.9251C38.8883 30.9251 41.0534 37.6173 48.5076 39.2001V48.6047L41.1478 51.6713C40.3931 51.9857 39.9015 52.7232 39.9015 53.5408V59.7856C39.9015 60.9042 40.8082 61.8109 41.9268 61.8109H62.1802C63.2988 61.8109 64.2055 60.9042 64.2055 59.7856V53.5408C64.2055 52.7232 63.7139 51.9857 62.9592 51.6713L55.0899 48.3924V39.2006C62.5458 37.6186 64.7114 30.9251 64.7114 30.9251V28.1704C67.4572 27.858 69.1545 25.8089 70.1495 23.6077C71.1704 21.3492 71.5505 18.7419 71.5945 17.0226C71.6001 16.8042 71.5173 16.5928 71.3648 16.4364C71.2123 16.2799 71.0031 16.1917 70.7847 16.1917H64.7114V14.2159H67.4956C68.1947 14.2159 68.7614 13.6492 68.7614 12.9501C68.7614 12.251 68.1947 11.6842 67.4956 11.6842L36.6091 11.6842ZM38.8883 26.5368V18.0646H33.6678C33.7943 19.5304 34.1655 21.4076 34.9186 23.0331C35.7766 24.8848 37.0476 26.2569 38.8883 26.5368ZM68.673 22.9403C67.8121 24.8449 66.5406 26.2468 64.7114 26.5355V17.8119H69.9288C69.8039 19.3214 69.432 21.2613 68.673 22.9403Z",
    fill: "#FFC86F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-trophy-shadow",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.9887 11.6851V29.9134C47.3262 31.3481 48.6596 34.4198 51.2925 35.23V50.1668C49.2672 51.2639 45.2165 53.6606 45.2165 54.4707V61.8118H41.9243C40.8058 61.8118 39.899 60.9051 39.899 59.7865V53.5417C39.899 52.724 40.3906 51.9866 41.1454 51.6721L48.5076 48.6046V39.2015C41.0514 37.6196 38.8858 30.926 38.8858 30.926V28.1714C36.1482 27.8675 34.4478 25.872 33.4485 23.7151C32.4253 21.5068 32.0445 18.9579 32.0003 17.2766C31.9945 17.0581 32.0773 16.8466 32.2298 16.69C32.3823 16.5335 32.5916 16.4452 32.8101 16.4452H38.8858V14.2168H36.6091C35.91 14.2168 35.3433 13.6501 35.3433 12.951C35.3433 12.2519 35.91 11.6851 36.6091 11.6851H46.9887ZM38.8858 18.0654V26.5374C37.0465 26.2566 35.7762 24.8849 34.9186 23.034C34.1655 21.4084 33.7943 19.5313 33.6678 18.0654H38.8858Z",
    fill: "#F1AE5B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "thumbnail-medal-ribbon",
    x: 54.9902,
    y: 11,
    width: 6.03224,
    height: 13.8742,
    rx: 0.482572,
    fill: "#F97953"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "thumbnail-medal-ribbon-stripe",
    x: 56.8008,
    y: 11,
    width: 2.4129,
    height: 13.8742,
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-medal",
    d: "M57.5473 19.6519C57.6918 19.2073 58.3208 19.2073 58.4652 19.6519L59.5231 22.9077C59.5877 23.1066 59.773 23.2412 59.9821 23.2412L63.4055 23.2412C63.873 23.2412 64.0673 23.8394 63.6891 24.1142L60.9195 26.1264C60.7504 26.2493 60.6796 26.4671 60.7442 26.6659L61.8021 29.9218C61.9466 30.3664 61.4377 30.7361 61.0595 30.4613L58.2899 28.4491C58.1208 28.3262 57.8918 28.3262 57.7226 28.4491L54.953 30.4613C54.5748 30.7361 54.066 30.3664 54.2104 29.9218L55.2683 26.6659C55.3329 26.4671 55.2621 26.2493 55.093 26.1264L52.3234 24.1142C51.9452 23.8394 52.1396 23.2412 52.6071 23.2412L56.0305 23.2412C56.2395 23.2412 56.4248 23.1066 56.4894 22.9077L57.5473 19.6519Z",
    fill: "#30444E"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "thumbnail-podium-circles",
    cx: 52.5,
    cy: 70.5,
    r: 3.5,
    fill: "#F5C58A"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "thumbnail-podium-circles",
    cx: 23.5,
    cy: 87.5,
    r: 3.5,
    fill: "#F5C58A"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "thumbnail-podium-circles",
    cx: 77.5,
    cy: 87.5,
    r: 3.5,
    fill: "#F5C58A"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "thumbnail-podium-circles",
    cx: 70.5,
    cy: 87.5,
    r: 3.5,
    fill: "#F5C58A"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "thumbnail-podium-circles",
    cx: 30.5,
    cy: 87.5,
    r: 3.5,
    fill: "#F5C58A"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "thumbnail-podium-circles",
    cx: 84.5,
    cy: 87.5,
    r: 3.5,
    fill: "#F5C58A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSportsThumbnail);
export default __webpack_public_path__ + "static/media/SportsThumbnail.32c84533cac7413ed1f859edea0e4c01.svg";
export { ForwardRef as ReactComponent };